export default class CaregiverBehaviorRatingModel {
  constructor () {
    this.badFeedbacks = 0
    this.goodFeedbacks = 0
    this.ratings = 0
  }

  static fromJSON (json) {
    let dashboard = new CaregiverBehaviorRatingModel()
    dashboard.badFeedbacks = json.badFeedbacks || 0
    dashboard.goodFeedbacks = json.goodFeedbacks || 0
    dashboard.ratings = json.ratings || 0
    return dashboard
  }
}
